import { useCallback } from "react";

import { useAtom } from "jotai";

import { assistantChatOpenAtom } from "../state";

interface UseAssistantChatOpenResult {
    isOpen: boolean;
    toggle: () => void;
    open: () => void;
    close: () => void;
}

export const useAssistantChatOpen = (): UseAssistantChatOpenResult => {
    const [isOpen, setOpen] = useAtom(assistantChatOpenAtom);
    const toggle = useCallback(() => {
        setOpen((previous) => !previous);
    }, [setOpen]);
    const open = useCallback(() => {
        setOpen(true);
    }, [setOpen]);
    const close = useCallback(() => {
        setOpen(false);
    }, [setOpen]);
    return { isOpen, toggle, open, close };
};
